/* TODO:

- Säulen !!!
- score (spieler als Klasse?)

schön sachen malen 

SCREENSHOTS AN b.kuhstoss@web.de


*/  

 import {pillar} from "./pillar"
 import {player} from "./player"

var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

// game variables

/*
var v_r = 100; // pixels per second
*/

var counter = 0;
var velocity = 1;

var game_player: player;
var pillars: pillar[] = [];
enum game_states {start, play, end}

var game_state = game_states.start;


var first_keypress = true;



// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();

//var plop = new Audio('plop.wav');

function calculate_background() {
    if (counter % 150 == 0) {
        pillars.push(new pillar(width + 10, Math.random(), context));
    }
}


function start() {
    if (keyStates.has("ArrowDown")) {
        game_player = new player(context, height);
        game_state = game_states.play;
        pillars = [];
    }
}

function play() {
    counter = (counter + 1);
    /*
    if (counter % 200 == 0) {
        velocity += 1;
    }
    */


    calculate_background();
    for (let p of pillars) {
        p.move(5);
        if (p.x_coord < -200) {
            pillars.splice(pillars.indexOf(p), 1);
        }
    }
    let end = game_player.fall(counter, pillars);
    if (end) {
        game_state = game_states.end;
    }
}

function draw() {
    context.fillStyle = `hsl(195, 92%, 75%)`;
    context.fillRect(0, 0, width, height);
    switch (game_state) {
        case game_states.start:
            context.strokeStyle = "black";
            context.fillStyle = "DarkRed";
            context.font = '64px serif';
            context.fillText("Flappy Birdy", 100, 150);
            context.strokeText("Flappy Birdy", 100, 150);
            context.font = '48px serif';
            context.fillText("Press v (keydown) to start", 100, 250);
            context.strokeText("Press v (keydown) to start", 100, 250);
            context.fillText("Press ^ to jump", 100, 300);
            context.strokeText("Press ^ to jump", 100, 300);
            break;
        case game_states.play:
            for (let p of pillars) {
                p.draw(height);
            }
            game_player.draw();
            context.fillStyle = "black";
            break;
        case game_states.end:
            context.fillStyle = "DarkRed";
            context.font = '64px serif';
            context.fillText("Game over :(", 100, 150);
            context.strokeText("Game over :(", 100, 150);
            context.font = '48px serif';
            context.fillText("Press v (keydown) to start again", 100, 250);
            context.strokeText("Press v (keydown) to start again", 100, 250);
            context.fillText("Score: " + game_player.score, 100, 300);
            context.strokeText("Score: " + game_player.score, 100, 300);

            break;
    }

}   


function update(dt: number) {
    /*
    // color
    hue = (hue + 1) % 360;
    color = `hsl(${counter}, 50%, 50%`;
    */
    switch (game_state) {
        case game_states.start:
            start();
            break;
        case game_states.play:
            play();
            break;
        case game_states.end:
            start();
            break;
    }
}


function loop(t_ms: number) {
    // calculate dt
    let dt = t_ms - last_tick_t;
    last_tick_t = t_ms;
    update(dt / 1000); // to seconds
    draw();
    window.requestAnimationFrame(loop);
}


function resized() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
}


function key(e: KeyboardEvent) {

    switch (e.type) {
        case "keydown":
            keyStates.add(e.key);
            if (e.key == "ArrowUp" && first_keypress){
                keyStates.add(e.key);
                first_keypress = false;
                game_player.jump(pillars);
            }
            break;
        case "keyup":
            keyStates.delete(e.key);
            first_keypress = true;
            break;
        
        default:
            console.warn(e.type);
    }
}


function main() {
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    resized();
    loop(performance.now());
}


main();